import React, { useMemo, useState, useEffect } from 'react';
import { Field, formValues, reduxForm, change } from 'redux-form';
import S from 'StyledRegisterWizardFormStep2.js';
import { translation } from 'helpers/utilsHelper.js';
import { isValueUnique, smsCodeVerifyWithAttempts } from 'authActions.js';
import { getPromoCookie } from 'cookiesHelper.js';
import Select from 'react-select';
import BackBtnArrowIcon from 'back-btn-icon.svg';
import BellIcon from 'bell-icon.svg';
import _find from 'lodash/find';
import _map from 'lodash/map';
import classNames from 'classnames';
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';

const validate = values => {
    const errors = validation(values, validators.REGISTER_STEP2);
    return errors;
};

const shouldAsyncValidate = ({pristine, trigger, syncValidationPasses}) => {
    if (!syncValidationPasses) {
        return false;
    }
    switch (trigger) {
        case 'blur':
        case 'change':
        case 'submit':
            return true;
        default:
            return false;
    }
};

const asyncValidate = async (values, dispatch, props, field) => {

    const previousErrors = props.asyncErrors;
    if (field) {
        const fieldName = field;
        const fieldValue = values[field];

        let requestAction = null;
        switch (fieldName) {
            case 'verificationCode':
                const mobileNumber = values['mobile'];
                requestAction = smsCodeVerifyWithAttempts.bind(null, fieldName, fieldValue, mobileNumber);
                break;
            default:
                requestAction = isValueUnique.bind(null, fieldName, fieldValue);
                break;
        }
        try {
            const result = await dispatch(requestAction());
            if(previousErrors) {
                throw 'prevErrors';
            } else {
                return result;
            }
        } catch (err) {
            const isObject = ({}).toString.call(err) == '[object Object]';

            if(err == 'prevErrors') {
                throw previousErrors;
            } else {
                if (isObject && fieldName == 'verificationCode'){
                    const {message, code} = err;
                    if (code == 440) {
                        // zaznacz checkbox emailVerification, jeśli user poda kilka razy niepoprawny kod
                        dispatch(change('registerForm','emailVerification', true));
                        throw Object.assign({}, previousErrors, {_error: translation(message), [fieldName]: [translation('account_registerForm_verificationCode_wrongSMSCode')]});
                    }
                } else {
                    throw Object.assign({}, previousErrors, { [fieldName]: [translation("account_registerForm_" + err)]});
                }
            }
        }
    }
};

const renderField = ({ input, label, type, readonly, meta: { touched, error, warning, valid, asyncValidating, submitFailed} }) => {
    const inputClass = classNames({
        'async-validating': asyncValidating,
        'has-error': ((touched || submitFailed) && error),
        'is-valid': ((touched || submitFailed) && valid)
    });

    if (input.name == 'verificationCode') {
        input['onKeyUp'] = function (e) {
            if (valid) {
                input.onBlur(input.value);
            }
        };
    }
    
    return (
        <S.Row>
         <S.InputWrapper>
            <S.Input {...input} type={type} required="required" className={inputClass} readOnly={readonly}/>
            <S.Label>{label}</S.Label>
            {(touched || submitFailed) && ((error && <S.Error>{error[0]}</S.Error>) || (warning &&
            <S.Error>{warning}</S.Error>))}
         </S.InputWrapper>
        </S.Row>
    );
};

const renderSelect = ({ input, options, meta: { touched, error, warning, valid, submitFailed }, isMulti }) => {
    return (
        <S.Row>
            <S.InputWrapper className="with-select">
                <S.Select as={Select}
                    options={options}
                    value={_find(options, { value: input.value })}
                    isSearchable={false}
                    classNamePrefix="react-select"
                    onChange={(props) => {
                        if (isMulti) {
                            input.onChange(props);
                        } else {
                            input.onChange(props.value);
                        }
                    }}
                    isMulti={isMulti}
                    formatOptionLabel={option => <div>{option.label}</div>}
                />
                {(touched || submitFailed) && ((error && <S.Error>{error[0]}</S.Error>) || (warning &&
                    <S.Error>{warning}</S.Error>))}
            </S.InputWrapper>
        </S.Row>
    )
};

const renderCheckbox = ({ input, label, required, meta: { touched, error, warning, submitFailed } }) => {
    let [fullText, setFullText] = useState(false);
 
    const toggleFullText = () => {

        if (label.length <= 100) {
            return;
        } else {
            setFullText(!fullText);
        }
     };
    
    const createLabelMarkup = () => {
        let more;
        let currLabel;
        if (!fullText && label.length > 100) {
            currLabel = label.slice(0, 100);
            more = `<span>(${translation('account_registerForm_showMore')})</span>`;
        } else if (label.length <= 100) {
            currLabel = label;
            more = '';
        } else {
            currLabel = label;
            more = `<span>(${translation('account_registerForm_showLess')})</span>`;
        }
        return { __html: `<span>${currLabel}</span>${more}` };
    };

    return (
        <S.Row>
            <S.CheckboxWrapper className="with-checkbox">
                <S.Input {...input} value={input.value} checked={input.value}
                    onChange={event => input.onChange(event.target.checked)} type="checkbox" required={required} />
                <S.FakeChbox>
                    {input.value && <S.CheckMark></S.CheckMark>}
                </S.FakeChbox>
                <label 
                    dangerouslySetInnerHTML={createLabelMarkup()} 
                    onClick={toggleFullText}
                />
                {(touched || submitFailed) && ((error && <S.Error>{translation(error[0])}</S.Error>) || (warning &&
                <S.Error>{warning}</S.Error>))}
            </S.CheckboxWrapper>
        </S.Row>
    );
};

let VerificationCodeToggler = ({emailVerification, change, validate,dispatch, ...rest}) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (emailVerification == true) {
            setShowModal(true)
        }
    }, [emailVerification]);

    const chooseEmailVerification = () => {
        change('verificationCode', null)
        setShowModal(false);
    };

    const chooseSmsVerification = () => {
        change('emailVerification', false);
        setShowModal(false);
    };

    return (
        <>
            {showModal && (
                <S.Modal>
                    <div className="confirm-modal-content">
                    <S.BellIcon dangerouslySetInnerHTML={{__html: BellIcon}}></S.BellIcon>
                        <S.ModalText>{translation('account_registerForm_modalConfirmTitle')}</S.ModalText>
                            <div className="buttonsWrapper">
                                <S.ModalButton onClick={chooseEmailVerification}>{translation('common_yes')}</S.ModalButton>
                                <S.ModalButton cancel onClick={chooseSmsVerification}>{translation('common_no')}</S.ModalButton>
                            </div>
                    </div>
                </S.Modal>
            )
            }
            
            {!emailVerification && (
                <Field
                    name="verificationCode"
                    type="text"
                    component={renderField}
                    label={translation('account_registerForm_smsCode')}
                />
            )}
        </>
    )
};
VerificationCodeToggler = formValues('emailVerification')(VerificationCodeToggler);


let DateOfBirthHidden =  ({dayOfBirth, monthOfBirth, yearOfBirth, change, touch}) => {

    useEffect(() => {
        change('dateOfBirth', `${yearOfBirth}-${('0'+(monthOfBirth+1)).substr(-2)}-${('0'+(dayOfBirth)).substr(-2)}`)
    }, [dayOfBirth, monthOfBirth, yearOfBirth]);

    useEffect(() => {
        touch('dateOfBirth');
    },[]);

    return (
            <Field
                name="dateOfBirth"
                component={renderField}
                type="hidden"
            />
        )
};

DateOfBirthHidden = formValues({'dayOfBirth':'dayOfBirth', 'monthOfBirth':'monthOfBirth', 'yearOfBirth':'yearOfBirth'})(DateOfBirthHidden);

let NationalityToggler = ({ nationality, touch, change }) => {

    const daysOptions = useMemo(() => {
        const days = app.service.Dict.getDaysForSelect();
        const options = days.map(({name, value}) => {
          let option;
          return option = {'label' : name, 'value': Number(value)}
        })
        return options;
  
      }, []);
  
      const monthsOptions = useMemo(() => {
          const months = app.service.Dict.getShortMonths();
          const options = months.map(({name, value}) => {
              let option;
              return option = {'label' : name, 'value': Number(value)}
            })
    
        return options;
    
        }, []);
  
        const yearsOptions = useMemo(() => {
          const years = app.service.Dict.getOnlyAdultYearsForSelect();
          const options = years.map(({name, value}) => {
              let option;
              return option = {'label' : name, 'value': Number(value)}
            })
    
        return options;
    
        }, []);


    return (nationality == 'PL' ?
        (
            <Field
                name="personalIdentifier"
                type="text"
                component={renderField}
                label={translation('account_registerForm_personalIdentifier')}
            />
        )
        :
        (
          <>
              <Field
                name="address"
                type="text"
                component={renderField}
                label={translation('account_registerForm_address')}
            />

            <Field
                name="postalCode"
                type="text"
                component={renderField}
                label={translation('account_registerForm_postalCode')}
            />

            <S.DateOfBirth>
            <Field
                name="dayOfBirth"
                component={renderSelect}
                options={daysOptions}
                label={translation('account_registerForm_dayOfBirth')}
            />
            <Field
                name="monthOfBirth"
                component={renderSelect}
                options={monthsOptions}
                label={translation('account_registerForm_monthOfBirth')}
            />
            <Field
                name="yearOfBirth"
                component={renderSelect}
                options={yearsOptions}
                label={translation('account_registerForm_yearOfBirth')}
            />
            </S.DateOfBirth>

            <DateOfBirthHidden change={change} touch={touch}/>
          </>
        )
    )
};

NationalityToggler = formValues('nationality')(NationalityToggler);

const RegisterWizardFormStep2 = (props) => {
    const { handleSubmit, goToPrevPage, touch, submitting, error, change, asyncValidating, isPromoCodeVisible, valid } = props;
    const countries = useMemo(() => {
        const countries = app.service.Language.__cachedDict.countries;
        const options = Object.keys(countries).map(key => {
            let option;
            return option = {'label' : countries[key], 'value': key}
        })

        options.sort((a, b) => a['label'].localeCompare(b['label']));
        return options;
    }, []);
    const promo = getPromoCookie();

    return (
        <S.RegisterWizardFormStep2 className="register-step2 row center-xs" onSubmit={handleSubmit} noValidate>
             
             {error && <S.SubmissionError className="submission-error">{error}</S.SubmissionError>}

            <S.FieldWrapper>
                <Field
                    name="firstName"
                    type="text"
                    component={renderField}
                    label={translation('account_registerForm_firstName')}
                />
                <Field
                    name="lastName"
                    type="text"
                    component={renderField}
                    label={translation('account_registerForm_lastName')}
                />
            </S.FieldWrapper>
            <Field
                name="nationality"
                component={renderSelect}
                options={countries}
                label={translation('account_registerForm_nationality')}
            />

            <NationalityToggler change={change} touch={touch} />

            <VerificationCodeToggler change={change}/>

            {isPromoCodeVisible && (
                <Field
                    name="promoCode"
                    type="text"
                    component={renderField}
                    label={translation('account_registerForm_promoCode')}
                    readonly={promo}
                />  
            )}  

            <Field
                name="emailVerification"
                component={renderCheckbox}
                label={translation('account_registerForm_emailVerification')}
                required={false}
            />

            <Field
                name="isBonus"
                component={renderCheckbox}
                label={translation('account_registerForm_bonus')}
            />
            
            <S.PreviousButton type="button" onClick={goToPrevPage}>
              <S.PrevIcon dangerouslySetInnerHTML={{ __html: BackBtnArrowIcon }}></S.PrevIcon>
            </S.PreviousButton>

            <S.SubmitButton type="submit" disabled={submitting ||  !valid}>
                {translation('account_registerForm_register')}
            </S.SubmitButton>

        </S.RegisterWizardFormStep2>
    )
}

export default reduxForm({
    form: 'registerForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
    asyncValidate,
    shouldAsyncValidate,
    asyncBlurFields: ['personalIdentifier', 'verificationCode'],
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(RegisterWizardFormStep2);